import faCalendarDuo from "icons/duotone/calendar-check.svg";
import faChartUpDuo from "icons/duotone/chart-line-up.svg";
import faCommentDotsDuo from "icons/duotone/comment-dots.svg";
import faCommentsQuestionCheckDuo from "icons/duotone/comments-question-check.svg";
import faSmileDuo from "icons/duotone/face-smile.svg";
import faGameBoardDuo from "icons/duotone/game-board.svg";
import faHatWizardDuo from "icons/duotone/hat-wizard.svg";
import faHomeDuo from "icons/duotone/house.svg";
import faLifeRingDuo from "icons/duotone/life-ring.svg";
import faListDuo from "icons/duotone/list.svg";
import faMapDuo from "icons/duotone/map.svg";
import faPenDuo from "icons/duotone/pen.svg";
import faPodcastDuo from "icons/duotone/podcast.svg";
import faScaleDuo from "icons/duotone/scale-balanced.svg";
import faTagDuo from "icons/duotone/tag.svg";
import faTelescopeDuo from "icons/duotone/telescope.svg";
import faTrophyDuo from "icons/duotone/trophy-star.svg";
import faUserFriendsDuo from "icons/duotone/users.svg";
import faWandMagicSparklesDuo from "icons/duotone/wand-magic-sparkles.svg";
import faCalendar from "icons/regular/calendar-check.svg";
import faChartUp from "icons/regular/chart-line-up.svg";
import faCommentDots from "icons/regular/comment-dots.svg";
import faCommentsQuestionCheck from "icons/regular/comments-question-check.svg";
import faSmile from "icons/regular/face-smile.svg";
import faGameBoard from "icons/regular/game-board.svg";
import faHatWizard from "icons/regular/hat-wizard.svg";
import faHome from "icons/regular/house.svg";
import faLifeRing from "icons/regular/life-ring.svg";
import faList from "icons/regular/list.svg";
import faMap from "icons/regular/map.svg";
import faPen from "icons/regular/pen.svg";
import faPodcast from "icons/regular/podcast.svg";
import faScale from "icons/regular/scale-balanced.svg";
import faTag from "icons/regular/tag.svg";
import faTelescope from "icons/regular/telescope.svg";
import faTrophy from "icons/regular/trophy-star.svg";
import faUserFriends from "icons/regular/users.svg";
import faWandMagicSparkles from "icons/regular/wand-magic-sparkles.svg";

export interface ExploreLinkType {
  name: string;
  href: string;
  icon: any;
  iconDuo: any;
  status?: string;
  description?: string;
  prefetch: boolean;
  tag?: "a" | "next" | null;
}

export const exploreLink: ExploreLinkType = {
  name: "Explore",
  href: "/explore",
  icon: faTelescope,
  iconDuo: faTelescopeDuo,
  description:
    "There is no single way to find great books. Here are a few of our favorite methods to filter through the stacks and discover great reads.",
  prefetch: true,
};

export const promptLink: ExploreLinkType = {
  name: "Prompts",
  href: "/prompts",
  icon: faCommentDots,
  iconDuo: faCommentDotsDuo,
  description:
    "Prompts are polls. Ask a question you're curious about, answer a popular prompt or dig into other readers answers to find hidden gems.",
  prefetch: true,
};

export const listLink: ExploreLinkType = {
  name: "Lists",
  href: "/lists",
  icon: faList,
  iconDuo: faListDuo,
  description:
    "Lists are organized collections of books created by anyone. Create a list and maybe we'll feature it!",
  prefetch: true,
};

export const trendingLink: ExploreLinkType = {
  name: "Trending Books",
  href: "/trending/month",
  icon: faChartUp,
  iconDuo: faChartUpDuo,
  description: "A list of what books are read the most on Hardcover.",
  prefetch: true,
};

export const upcomingLink: ExploreLinkType = {
  name: "Upcoming Books",
  href: "/upcoming/month",
  icon: faCalendar,
  iconDuo: faCalendarDuo,
  description: "A list of what books are most anticipated on Hardcover.",
  prefetch: true,
};

export const recommendationLink: ExploreLinkType = {
  name: "Recommendations",
  href: "/recommendations",
  icon: faWandMagicSparkles,
  iconDuo: faWandMagicSparklesDuo,
  status: "beta",
  description:
    "Books we think you'll love based on every book you've rated on Hardcover.",
  prefetch: true,
};

export const feedLink: ExploreLinkType = {
  name: "Feed",
  href: "/feed",
  icon: faHome,
  iconDuo: faHomeDuo,
  description: "See what others readers you follow are up to.",
  prefetch: true,
};

export const dashboardLink = {
  name: "Dashboard",
  href: "/dashboard",
  icon: faChartUp,
  iconDuo: faChartUpDuo,
  description: "Your new home page.",
  prefetch: false,
  status: "beta",
};

const explore: ExploreLinkType[] = [
  promptLink,
  listLink,
  recommendationLink,
  trendingLink,
  upcomingLink,
  feedLink,
  dashboardLink,
];

export const genreLink: ExploreLinkType = {
  name: "Genres",
  href: "/browse/tags/genre",
  icon: faHatWizard,
  iconDuo: faHatWizardDuo,
  description: "Browse books by genre.",
  prefetch: true,
};

export const moodLink: ExploreLinkType = {
  name: "Moods",
  href: "/browse/tags/mood",
  icon: faSmile,
  iconDuo: faSmileDuo,
  description: "Browse books by mood.",
  prefetch: true,
};

export const tagLink: ExploreLinkType = {
  name: "Tags",
  href: "/browse/tags/tag",
  icon: faTag,
  iconDuo: faTagDuo,
  description: "Browse books by tag.",
  prefetch: true,
};

const tags: ExploreLinkType[] = [genreLink, moodLink, tagLink];

export const bookleLink: ExploreLinkType = {
  name: "Bookle",
  href: "/bookle/all",
  icon: faGameBoard,
  iconDuo: faGameBoardDuo,
  status: "new",
  description: "A Wordle-like game to identify book pixelated book covers.",
  prefetch: true,
};

export const readersLink = {
  name: "Readers & Supporters",
  href: "/readers",
  icon: faUserFriends,
  iconDuo: faUserFriendsDuo,
  description: "Find other readers and see who's supporting Hardcover.",
  prefetch: true,
};

export const blogLink = {
  name: "Blog",
  href: "/blog",
  icon: faPen,
  iconDuo: faPenDuo,
  description: "Read more about Hardcover and what we're up to.",
  prefetch: true,
};

export const liveLink = {
  name: "Hardcover Live",
  href: "/live",
  icon: faPodcast,
  iconDuo: faPodcastDuo,
  description: "Our weekly live show where we build Hardcover in public.",
  prefetch: true,
};

export const roadmapLink = {
  name: "Roadmap & Requests",
  href: "/api/roadmap",
  icon: faMap,
  iconDuo: faMapDuo,
  description: "See what we're up to next and upvote what you'd like to see.",
  prefetch: false,
  tag: "a",
};

export const supportLink = {
  name: "Support",
  href: "/pages/support",
  icon: faLifeRing,
  iconDuo: faLifeRingDuo,
  description: "How to reach out with a bug report, question or suggestion.",
  prefetch: false,
};
export const policiesLink = {
  name: "Policies & Terms",
  href: "/pages/policies",
  icon: faScale,
  iconDuo: faScaleDuo,
  description: "If you're into legal mumbo jumbo, you'll love this.",
  prefetch: false,
};

export const faqLink = {
  name: "Frequently Asked Questions",
  href: "/pages/faq",
  icon: faCommentsQuestionCheck,
  iconDuo: faCommentsQuestionCheckDuo,
  description: "Have a question? Check here first!",
  prefetch: false,
};

const play: ExploreLinkType[] = [readersLink, blogLink, liveLink, roadmapLink];

export const yib2023 = {
  name: "2023 Year in Books",
  href: "/2023",
  icon: faTrophy,
  iconDuo: faTrophyDuo,
  description: "What was most popular on Hardcover in 2023?",
  prefetch: false,
};
export const yib2024 = {
  name: "2024 Year in Books",
  href: "/2024",
  icon: faTrophy,
  iconDuo: faTrophyDuo,
  description: "What was most popular on Hardcover in 2024?",
  prefetch: false,
};

const labs: ExploreLinkType[] = [yib2023, yib2024];

export const exploreLinks = [explore, tags, play, labs];
